import { render, staticRenderFns } from "./svgHelper.vue?vue&type=template&id=5bd15fea"
import script from "./svgHelper.vue?vue&type=script&lang=js"
export * from "./svgHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports